import { Mail, Sparkles, Zap } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateCustomerEmailRepliesWithAiAr: TemplateAr = {
  name: 'أتمتة الرد على إيميلات العملاء بالذكاء الاصطناعي',
  description:
    'صياغة وإرسال ردود دقيقة وبنبرة علامتك على إيميلات العملاء، بدمج قاعدة معرفتك مع المحادثة الجارية.',
  category: 'دعم العملاء',
  workflow: [
    { icon: Mail, label: 'إيميل وارد' },
    { icon: Sparkles, label: 'الـ AI يصيغ' },
    { icon: Zap, label: 'إرسال', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خلّ الإيميل الوارد يلقى ردّه بدون ما تفتحه. الـ AI يقرأ الرسالة، ويرجع لقاعدة معرفتك، ويصيغ رداً يحل الموضوع من أوله لآخره. ويتكفّل بالذيل الطويل من إيميلات الدعم المتكررة: حالة الطلب، والإرجاع، وإعادة تعيين كلمة المرور، وأسئلة الحساب. وأي أمر غامض أو حسّاس يوجّهه لموظف بشري، والسياق كامل معه.',
    paragraph2:
      'أنت اللي تحدد النبرة والتوقيع وحد الثقة اللي يرسل عنده تلقائياً أو يخلي المسودة للمراجعة. والردود توصل لصندوقك الحالي (Zendesk، HubSpot، Intercom، Freshdesk، Salesforce، Front، Gmail) بنفس الطريقة اللي يرد بها الموظف البشري، فتقاريرك واستطلاعات CSAT تستمر كما هي. وتقييم الثقة والتقييم الذاتي مدمجان، ومعهم تتبّع للاستدلال تراجعه وقت التدقيق.',
  },
  benefits: [
    'الذيل الطويل من إيميلات الدعم المتكررة ينحل تلقائياً',
    'مسودة تلقائية أو إرسال تلقائي، وأنت اللي تحدد حد الثقة',
    'نبرة وتوقيع ولغة تمشي مع علامتك',
    'كل إيميل معه تتبّع للاستدلال ودرجة ثقة',
    'AHT الإيميل ينزل ٦٠–٨٠٪ في الطلبات الروتينية',
    'يشتغل مع Zendesk وHubSpot وIntercom وFreshdesk وSalesforce وFront وGmail',
  ],
};
